import React from 'react';

export const DeleteIcon = (): JSX.Element => (
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="18" height="20">
        <path d="M16.998 6h-.999v10.999c0 1.657-1.343 3-3 3h-8c-1.657 0-3.001-1.343-3.001-3V6H.999c-.552 0-1-.449-1-1.001 0-.553.448-1 1-1h4v-1c0-1.657 1.343-3 3-3h2c1.656 0 3 1.343 3 3v1h3.999c.553 0 1.001.447 1.001 1 0 .552-.448 1.001-1.001 1.001zm-5.999-3.001c0-.552-.449-1-1-1h-2c-.552 0-1 .448-1 1v1h4v-1zM13.998 6H3.999v10.999c0 .552.448 1 1 1h8c.552 0 .999-.448.999-1V6z" />
    </svg>
);
